/**
 * @desc 针对页面上r非0或者code非0时，业务上有处理，需要返回res的接口
 */
const businessErrorWhiteList: string[] = [
    // 敏感词设置
    '/tp/sensitiveWords/deleteSensitiveWordSet',
    '/tp/sensitiveWords/getList',
    '/tp/sensitiveWords/setCorpFeatureStatus',
    '/tp/sensitiveWords/update',
    '/tp/sensitiveWords/create',
    // 企业资料
    '/mng/account/relatedCorp/uploadQualification',
    '/mng/account/corpInfo/UploadAttachment?type=upload',
    // 微信运营
    '/mng/account/embed/SignUp',
    // 绑定手机、发送验证码
    '/mng/contactInfo/sendVerifySMS',
    '/mng/contactInfo/verifyEmailCode',
];

export default businessErrorWhiteList;
